import { Col, Container, Row } from "reactstrap";

const Scholarship = () => {
  return (
    <section className="section" id="scholarship">
      <Container>
        <Row className="">
          <Col xs='12' lg='5'>
          <img
            src="assets/images/scholarship.webp" 
            alt="students-apply-for-scholarship-illustration"
            className="img-fluid" 
            loading="lazy" 
          />
          </Col>
          <Col xs='12' lg='7'>
            <h1 className="mt-3 mt-lg-0 mb-3">Info Beasiswa</h1>
            <div>
              <h2><b>International Priority Program Scholarship</b></h2>
              <ul>
                <li>Potongan: 10% dari tuition fees.</li>
                <li>Syarat: Daftar di kursus prioritas (termasuk IT, engineering, arts, business, hospitality, dll).</li>
                <li>Cara dapat: Centang pilihan beasiswa pas daftar.</li>
              </ul>
            </div>
            <div>
              <h2><b>International Higher Education Scholarships</b></h2>
              <ul>
                <li>Potongan: 10% - 20% dari tuition fees.</li>
                <li>Syarat: Nilai akademik kamu memenuhi threshold tertentu.</li>
                <li>Keuntungan: Diskon sepanjang masa studi.</li>
              </ul>
            </div>   
            <p className="note">*Ada juga opsi beasiswa Transnational, bahkan potongan hingga 50% kalau kamu sudah lulus program offshore partner.</p>         
          </Col>          
        </Row>
      </Container>
    </section>
  );
};

export default Scholarship;